import React, { Component } from 'react'
import config from '../../config.json'
import { renderHegaxonMap, addMarkers, updateHexaGrid, centerCurrentLocation, addSimulatedMarker } from '../map'
import { addWish, db } from '../../db'
import { getImageSrcForWish, wishCategories } from '../wishes/wishes'
import { IWish, ILocation } from 'types'
import { ActionSheet, WingBlank, WhiteSpace, Button, Toast } from 'antd-mobile'
import { connect } from 'react-redux'
import { RematchRootState } from '@rematch/core'
import { models } from '../../store'
import { Wish } from '../../models/wishes'

// fix touch to scroll background page on iOS
// https://github.com/ant-design/ant-design-mobile/issues/307
// https://github.com/ant-design/ant-design-mobile/issues/163
// const isIPhone = new RegExp('\\biPhone\\b|\\biPod\\b', 'i').test(window.navigator.userAgent);
// let wrapProps;
// if (isIPhone) {
//   wrapProps = {
//     onTouchStart: e => e.preventDefault(),
//   };
// }

type WishesProps = {} & ReturnType<typeof mapStateToProps>

type WishesState = {
  selectedHexagon: H.map.Polygon | null
  selectedType: string | null // IWish['type']
}

class Wishes extends Component<WishesProps, WishesState> {
  constructor(props: WishesProps) {
    super(props)
    this.mapElement = React.createRef()
    this.state = {
      selectedHexagon: null,
      selectedType: null,
    }
  }

  mapElement: React.RefObject<HTMLDivElement>
  map: H.Map | null = null
  simulatedMarkerIntervalId: number
  dataList = wishCategories.map(obj => ({
    icon: <img src={obj.imageSrc} width={48} />,
    title: obj.name,
  }))

  showActionSheet = (center: H.geo.Point) => {
    ActionSheet.showShareActionSheetWithOptions(
      {
        options: this.dataList,
        title: 'Was wünschst du dir hier?',
      },
      buttonIndex => {
        const selectedType = buttonIndex > -1 ? this.dataList[buttonIndex].title : 'cancel'
        this.setState({ selectedType })

        return new Promise(resolve => {
          if (selectedType !== 'cancel') {
            Toast.info(`Du wünschst dir ein ${selectedType}!`, undefined, undefined, false)
            addWish({
              id: '',
              lat: center.lat,
              lng: center.lng,
              type: wishCategories.find(category => category.name === selectedType)!.type,
              user: 'anonymous',
              createdAt: Date.now(),
            }).then(resolve)
          } else {
            resolve()
          }
        })
      }
    )
  }

  selectHexagon = (selectedPoint: ILocation, fillColor = 'rgba(230, 190, 0, .4)') => {
    const screenCoords = this.map!.geoToScreen(new H.geo.Point(selectedPoint.lat, selectedPoint.lng))
    const hexagon = this.map!.getObjectAt(screenCoords.x, screenCoords.y) as H.map.Polygon

    if (hexagon && hexagon instanceof H.map.Polygon) {
      hexagon.setStyle({
        ...hexagon.getStyle(),
        fillColor,
      })
    }
  }

  getWishMarker = (wish: Wish, index: number, wishes: Wish[]) => {
    const goldenAngle = Math.PI * (3 - Math.sqrt(5))
    const theta = index * goldenAngle
    const r = Math.sqrt(index) / Math.sqrt(wishes.length)
    return new H.map.Marker(
      {
        lat: wish.lat + r * Math.cos(theta) * 0.001,
        lng: wish.lng + r * Math.sin(theta) * 0.001,
      },
      {
        icon: new H.map.Icon(getImageSrcForWish(wish.type as IWish['type']), {
          crossOrigin: false,
          size: {
            w: 48,
            h: 48,
          },
        }),
        data: {
          type: wish.type,
          user: wish.user,
        },
      }
    )
  }

  handleSelectHexagon = (newSelectedHexagon: H.map.Polygon) => {
    const { selectedHexagon } = this.state

    if (selectedHexagon) {
      selectedHexagon.setStyle({
        ...selectedHexagon.getStyle(),
        fillColor: 'transparent',
      })
    }

    newSelectedHexagon.setStyle({
      ...newSelectedHexagon.getStyle(),
      fillColor: 'rgba(230, 190, 0, .4)',
    })

    this.setState({
      selectedHexagon: newSelectedHexagon,
    })

    const center = newSelectedHexagon.getBounds().getCenter()
    this.showActionSheet(center)
  }

  componentDidUpdate() {
    if (this.props.selectedPoint) {
      this.selectHexagon(this.props.selectedPoint, 'rgba(18, 115, 115, .4)')
    }
  }

  componentDidMount() {
    const unsubscribeFromWishes = db.collection('wish').onSnapshot(wish => {
      const wishMarkers = wish.docs
        .map(doc => doc.data())
        .sort((a: Wish, b: Wish) => a.createdAt - b.createdAt)
        .map(this.getWishMarker)
      addMarkers(this.map!, wishMarkers)
    })

    if (this.mapElement.current !== null) {
      this.map = renderHegaxonMap(this.mapElement.current, this.handleSelectHexagon, {
        app_id: config.here.id,
        app_code: config.here.code,
        useHTTPS: true,
      })
    }

    if (this.props.selectedPoint) {
      this.selectHexagon(this.props.selectedPoint)
    }
  }

  componentWillUnmount() {
    if (this.simulatedMarkerIntervalId) {
      clearInterval(this.simulatedMarkerIntervalId)
    }
    if (this.map !== null) {
      this.map.dispose()
    }
  }

  render() {
    return <div className="map-wrapper" ref={this.mapElement} />
  }
}

function mapStateToProps(state: RematchRootState<models>) {
  return {
    selectedPoint: state.wishes.currentLocation,
  }
}

export default connect(mapStateToProps)(Wishes)



// WEBPACK FOOTER //
// ./src/components/routes/Wishes.tsx